import React, { useState } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever
} from "@mui/icons-material";

import { 
  AttachedTable,
  Potence,
  UpgradableNumber
} from "@dndModels";
import { ABILITY_SCORES, CHARACTER_LEVELS } from "@dndModels/Constants";
import { AbilityScoreType } from "@dndModels/Types";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

interface Props {
  obj: Potence;
  disabled?: boolean;
  onChange: (changed: Potence) => void;
  onDelete: () => void;
  attached_table?: AttachedTable;
  min_potence?: number;
  max_potence?: number;
}

export default function AbilityPotenceInput({ 
  obj,
  onChange,
  onDelete,
  disabled = false,
  attached_table,
  min_potence = -1,
  max_potence = -1
}: Props) {
  const [myObj, setObj] = useState(obj.clone());
  const [basic, setBasic] = useState(obj.rolls.flat.isBasic() && obj.rolls.count.isBasic() && obj.rolls.size.isBasic());

  const handleChange = (changed: Potence) => {
    // debugger;
    setObj(changed);
    onChange(changed);
  }

  const potence_level_options = min_potence === -1 && max_potence === -1 ? CHARACTER_LEVELS : CHARACTER_LEVELS.filter(o => +o >= min_potence && (max_potence === -1 || +o <= max_potence));
  return (
    <Grid size={12}
      container spacing={0} direction="row">
      <Grid size={1}>
        <SelectStringBox 
          name="Level"
          options={potence_level_options}
          value={`${myObj.level}`} 
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = myObj.clone();
            new_obj.level = +changed;
            handleChange(new_obj);
          }}
        />
      </Grid>
      <Grid size={2}>
        <ToggleButtonBox 
          name="Basic"
          value={basic} 
          disabled={disabled}
          onToggle={() => {
            if (!basic) {
              const new_obj = myObj.clone();
              new_obj.rolls.flat.makeBasic();
              new_obj.rolls.count.makeBasic();
              new_obj.rolls.size.makeBasic();
              handleChange(new_obj);
            }
            setBasic(!basic);
          }}
        />
      </Grid>
      { basic ? 
        <Grid size={2}>
          <StringBox 
            name="Dice Count"
            value={`${myObj.rolls.count.base}`} 
            disabled={disabled}
            type="number"
            onBlur={(changed: string) => {
              const new_obj = myObj.clone();
              new_obj.rolls.count.base = +changed;
              handleChange(new_obj);
            }}
          />
        </Grid>
      :
        <Grid size={2}>
          <UpgradableNumberBox 
            name="Dice Count"
            value={myObj.rolls.count} 
            disabled={disabled}
            attached_table={attached_table}
            onChange={(changed: UpgradableNumber) => {
              const new_obj = myObj.clone();
              new_obj.rolls.count = changed;
              handleChange(new_obj);
            }}
          />
        </Grid>
      }
      { basic ? 
        <Grid size={2}>
          <StringBox 
            name="Dice Size"
            value={`${myObj.rolls.size.base}`} 
            disabled={disabled}
            type="number"
            onBlur={(changed: string) => {
              // debugger;
              const new_obj = myObj.clone();
              new_obj.rolls.size.base = +changed;
              handleChange(new_obj);
            }}
          />
        </Grid>
      :
        <Grid size={2}>
          <UpgradableNumberBox 
            name="Dice Size"
            value={myObj.rolls.size} 
            disabled={disabled}
            attached_table={attached_table}
            onChange={(changed: UpgradableNumber) => {
              const new_obj = myObj.clone();
              new_obj.rolls.size = changed;
              handleChange(new_obj);
            }}
          />
        </Grid>
      }
      { basic ? 
        <Grid size={2}>
          <StringBox 
            name="Flat"
            value={`${myObj.rolls.flat.base}`} 
            disabled={disabled}
            type="number"
            onBlur={(changed: string) => {
              const new_obj = myObj.clone();
              new_obj.rolls.flat.base = +changed;
              handleChange(new_obj);
            }}
          />
        </Grid>
      :
        <Grid size={2}>
          <UpgradableNumberBox 
            name="Flat"
            value={myObj.rolls.flat} 
            disabled={disabled}
            quick_options={ABILITY_SCORES as AbilityScoreType[]}
            attached_table={attached_table}
            onChange={(changed: UpgradableNumber) => {
              const new_obj = myObj.clone();
              new_obj.rolls.flat = changed;
              handleChange(new_obj);
            }}
          />
        </Grid>
      }
      <Grid size={2}>
        <StringBox 
          name="Extra"
          value={myObj.extra} 
          disabled={disabled}
          onBlur={(changed: string) => {
            const new_obj = myObj.clone();
            new_obj.extra = changed;
            handleChange(new_obj);
          }}
        />
      </Grid>
      <Grid size={1}>
        { !disabled &&
          <Tooltip title={`Delete Potence`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
    </Grid>
  );
}
